export default class BackBtn {
    constructor() {
        this.button = document.querySelector(".return-btn");
        if (this.button) {
            this.returnBtn();
        }
    }

    returnBtn() {
        this.button.addEventListener("click", () => {
            window.history.back();
        });
    }
}
